import { render, staticRenderFns } from "./invoiceIncomeCreatePage.vue?vue&type=template&id=223010e4&"
import script from "./invoiceIncomeCreatePage.vue?vue&type=script&lang=ts&"
export * from "./invoiceIncomeCreatePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports